import {GenericObject} from "./generic-object.model";
import {OrderSettlement} from "./order-settlement.model";

/**
 * Model reprezentujący zbiorcze zestawienie rozliczeń (Summary Settlement).
 * Służy do agregacji pojedynczych transakcji z danego okresu rozliczeniowego
 * w jeden dokument podsumowujący (np. miesięczny raport prowizyjny dla kliniki).
 */
export class SummarySettlement extends GenericObject {

  /** Tablica pojedynczych rozliczeń zamówień/wizyt wchodzących w skład tego zestawienia.
   */
  public settlements: OrderSettlement[];

  /** Data i czas wygenerowania dokumentu zbiorczego w systemie. */
  public created: Date;

  /** Formalny numer raportu/zestawienia.
   */
  public reportNumber: string;

  /** Procentowa stawka prowizji pobierana za obsługę płatności online.
   */
  public percentageOnlineFeeValue: number;

  /** Procentowa stawka prowizji platformy za zrealizowaną wizytę lub usługę. */
  public percentageVisitFeeValue: number;

  /** Wyliczona łączna kwota potrącona z tytułu opłat za płatności online. */
  public onlineFeeValue: number;

  /** Wyliczona łączna kwota potrącona z tytułu prowizji od samych wizyt/usług. */
  public visitFeeValue: number;

  /** Całkowity obrót ze wszystkich zamówień i transakcji
   * wchodzących w skład tego zestawienia.
   */
  public sumOfOrders: number;

  /** Całkowita suma pobranych opłat i prowizji (przychód operatora platformy).
   */
  public sumOfFee: number;


  /** Identyfikator konkretnej placówki, której dotyczy to podsumowanie.
   */
  public vetCodeId: number;

}
